import {useLocation, Link} from "react-router-dom";

export default function NavLink({className = '', children, ...props }) {
    const location = useLocation();
    const active = location.pathname === props.to;
    return (
        <Link
            {...props}
            className={
                'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium leading-5 transition duration-150 ease-in-out focus:outline-none ' +
                (active
                    ? 'border-blue-400 text-white focus:border-indigo-700 '
                    : 'border-transparent text-gray-500 hover:text-gray-200 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300 ') +
                className
            }
        >
            {children}
        </Link>
    );
}
